import { useState, useEffect } from 'react';

const useForm = (callback, validate, initial) => {

  const [values, setValues] = useState(initial || {});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
        setIsSubmitting(false);
        callback(values);
    }
  }, [errors, values, callback, isSubmitting]);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values));
    setIsSubmitting(true);
  };

  /*
  const handleChange = (event) => {
    event.persist();
    setValues(values => ({ ...values, [event.target.name]: event.target.value }));
  };
  */
 const handleChange = (name, value) => {
    setValues(values => ({ ...values, [name]: value}));
 }

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
  }
};

export default useForm;
